import React, { Component } from "react";

import ValidatedRegisterForm from "../components/ValidatedRegisterForm";
import WrappedUp from "../containers/WrappedUp";
import AccountList from "../components/AccountList";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCloudUpload} from "@fortawesome/free-solid-svg-icons";

class DashboardPage extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <WrappedUp>
          <a
              className="btn btn-cta float-end"
              href="/UploadData"
          >
              <FontAwesomeIcon size="lg" icon={faCloudUpload} />
              &nbsp; Importer des données
              <div className="btn-cta-overlay"></div>
          </a>
          <h1 className="dashboardTitle">Trésorerie</h1>

        <AccountList showWelcomingPrompt hideInactive />
      </WrappedUp>
    );
  }
}

export default DashboardPage;
